const features = [
  {
    icon: 'ri-global-line',
    title: '全站资源覆盖',
    desc: '汇聚久久视频、芒果视频、97视频、丝瓜视频、蓝莓视频等200+在线视频网站资源，视频播放器在线看视频入口一站直达。',
  },
  {
    icon: 'ri-timer-flash-line',
    title: '每日实时更新',
    desc: '专业团队每日巡检在线视频网站状态，确保各站点视频资源入口的可用性与新鲜度，让用户第一时间获取最新内容。',
  },
  {
    icon: 'ri-device-line',
    title: '多端无缝适配',
    desc: '桌面端与移动端全面优化，无论在电脑还是手机上都能流畅使用视频播放器在线看视频的全部功能。',
  },
  {
    icon: 'ri-shield-star-line',
    title: '安全稳定保障',
    desc: '所有收录的在线视频网站均经过安全审核，保障用户在使用视频播放器在线看视频过程中的信息安全与访问稳定。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading text-center mb-4">
          平台优势
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-12 max-w-lg mx-auto">
          国产91视频为您提供全方位的在线视频网站资源导航与视频播放器在线看视频服务
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((item, i) => (
            <div key={i} className="bg-background-100 rounded-xl border border-background-200/70 p-6 hover:border-primary-200/60 transition-all cursor-pointer group text-center">
              <div className="w-14 h-14 rounded-2xl bg-accent-100 flex items-center justify-center mx-auto mb-5 group-hover:bg-accent-200 transition-colors">
                <i className={`${item.icon} text-2xl text-accent-600`}></i>
              </div>
              <h3 className="text-base font-bold text-foreground-800 mb-3">{item.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}